import React from "react"
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap"
import { BROKER_BID_BLOCKED_MESSAGE } from "helpers/biddingAccess"

export interface BrokerBidBlockedModalProps {
  isOpen: boolean
  toggle: () => void
  message?: string
}

/** Centered modal when a broker tries to bid on a listing that does not allow broker bidding. */
const BrokerBidBlockedModal: React.FC<BrokerBidBlockedModalProps> = ({
  isOpen,
  toggle,
  message = BROKER_BID_BLOCKED_MESSAGE,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="md"
      contentClassName="border-0 shadow-lg rounded-4 overflow-hidden"
    >
      <ModalHeader
        toggle={toggle}
        className="border-0 pb-0 pt-4 px-4 text-center flex-column align-items-center position-relative"
      >
        <div
          className="rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center mx-auto mb-3"
          style={{ width: 72, height: 72 }}
        >
          <i className="mdi mdi-gavel text-danger" style={{ fontSize: 40 }} aria-hidden />
        </div>
        <span className="h5 mb-0 fw-semibold text-body">You cannot place a bid</span>
      </ModalHeader>
      <ModalBody className="px-4 pb-4 pt-2 text-center">
        <p className="text-body mb-3 fw-medium lh-base">{message}</p>
        <p className="text-muted mb-4 small lh-base">
          This property is open for buyer bidding only. If you are bidding on behalf of a client, please ask the buyer
          to register and place the bid using their own account.
        </p>
        <Button color="primary" className="py-2 fw-semibold w-100" onClick={toggle}>
          Got it
        </Button>
      </ModalBody>
    </Modal>
  )
}

export default BrokerBidBlockedModal
